let html = `<div class="bookmarks-folder card selector layer--visible layer--render">
    <div class="bookmarks-folder__inner card__view">
        <div class="bookmarks-folder__layer">
            <div class="bookmarks-folder__head">
                <div class="bookmarks-folder__title"></div>
                <div class="bookmarks-folder__num"></div>
            </div>

            <div class="bookmarks-folder__body"></div>
        </div>
    </div>
</div>`

export default html